<template>
  <v-runtime-template :template="finishedText" />
</template>

<script>
import VRuntimeTemplate from 'v-runtime-template'
import CatalogItemSmall from '@/components/CatalogItemSmall'

export default {
  name: 'ArticleWrapper',
  // eslint-disable-next-line vue/no-unused-components
  components: { VRuntimeTemplate, CatalogItemSmall },
  props: {
    article: {
      type: String,
      required: true
    }
  },
  async fetch () {
    this.finishedText = await this.prepareText(this.article)
  },
  data: () => {
    return {
      finishedText: null,
      widgetMap: {}
    }
  },
  computed: {
    categories () {
      return this.$store.state.categories
    },
    styles () {
      return this.$store.state.styles
    }
  },
  methods: {
    hashCode (s) {
      let h = 0; const l = s.length; let i = 0
      if (l > 0) {
        while (i < l) { h = (h << 5) - h + s.charCodeAt(i++) | 0 }
      }
      return h
    },
    async prepareText (value) {
      const shortCodeSchema = /\{.*\}/g
      const result = value.match(shortCodeSchema)
      if (result) {
        for (let i = 0; i < result.length; i++) {
          const widgetData = JSON.parse(result[i])
          const componentData = {
            category: this.categories.find((item) => {
              return item.id === widgetData.idCat
            })
          }
          if (widgetData.idStyle) {
            componentData.style = this.styles.find((item) => {
              return item.id === widgetData.idStyle
            })
          }
          componentData.item = await this.$store.dispatch('loadItemById', widgetData.idItem)
          this.widgetMap[this.hashCode(result[i])] = { shortCode: result[i], componentData }
        }
        for (const key in this.widgetMap) {
          if (this.widgetMap[key].componentData.item) {
            value = value.replace(new RegExp(this.widgetMap[key].shortCode, 'g'), `<CatalogItemSmall :item="widgetMap[${key}].componentData.item" :category="widgetMap[${key}].componentData.category" :styleProp="widgetMap[${key}].componentData.style" />`)
          }
        }
      }

      return '<div class="detail-text">' + value + '</div>'
    }
  }
}

</script>
